import { Avatar } from '@components/ui/Avatar/Avatar';
import { MessageSquareIcon } from '@utils/icons';
import styles from './CommsUnreadVisual.module.css';

const SIZE = 24;

interface ICommsUnreadVisualProps {
  name?: string;
  isChannel?: boolean;
}

/**
 * What stands in front of a chat notification: the conversation's avatar,
 * drawn from its name as the Comms hub draws it (# for a channel) — or a chat
 * icon while there is no name to draw from.
 */
export function CommsUnreadVisual({ name, isChannel = false }: ICommsUnreadVisualProps) {
  if (name) return <Avatar name={name} glyph={isChannel ? '#' : undefined} size={SIZE} tinted />;

  return (
    <span className={styles.icon} aria-hidden="true">
      <MessageSquareIcon size={14} />
    </span>
  );
}
